import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import {
  SUBMITTED,
  PROCESSING,
  AWAITING_CUSTOMER_REVIEW,
  VERIFIED,
} from '../../../../constants/issueStatuses';

const getStatusColor = status => {
  switch (status) {
    case SUBMITTED:
      return 'primaryBase';
    case PROCESSING:
      return 'secondaryText';
    case AWAITING_CUSTOMER_REVIEW:
      return 'lightDanger';
    case VERIFIED:
      return 'success';
    default:
      return 'secondaryText';
  }
};

export const StatusBadgeWrapper = styled(Box).attrs({
  borderRadius: '5px',
  px: 20,
  py: '3px',
})`
  color: ${({ theme, status }) => theme.colors[getStatusColor(status)]};
  font-size: 12px;
  border: 1px solid
    ${({ theme, status }) => theme.colors[getStatusColor(status)]};
`;
